"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAlertEventSchema = exports.APosAlertEventTypeSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
exports.APosAlertEventTypeSchema = zod_1.z.enum([
    'alert_created', 'employees_notified', 'shelf_pull_started',
    'shelf_pull_confirmed', 'customers_identified', 'customers_notified',
    'inventory_quarantined', 'rma_requested', 'employee_acknowledged',
    'resolved', 'escalated',
]);
exports.APosAlertEventSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    alertId: id_schema_1.EntityIdSchema,
    eventId: id_schema_1.EntityIdSchema,
    eventType: exports.APosAlertEventTypeSchema,
    timestamp: zod_1.z.number(),
    userId: id_schema_1.EntityIdSchema.optional(),
    locationId: id_schema_1.EntityIdSchema.optional(),
    details: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    ipAddress: zod_1.z.string().optional(),
});
//# sourceMappingURL=alert-event.schema.js.map